import * as TYPES from "./types";
export var storeCurrentMenuItemPosition = function (data) { return ({ type: TYPES.CURRENT_MENU_ITEM_POSITION, data: data }); };
export var storeSelectedMenuItemPosition = function (data) {
    return function (dispatch) {
        dispatch(storeCurrentMenuItemPosition(data));
    };
};
export var storeCurrentParentMenuItemPosition = function (data) { return ({ type: TYPES.CURRENT_PARENT_MENU_ITEM_POSITION, data: data }); };
export var storeSelectedParentMenuItemPosition = function (data) {
    return function (dispatch) {
        dispatch(storeCurrentParentMenuItemPosition(data));
    };
};
